<proffeo-ui-dialog [title]="dialogTitleKey() | translate">
  <form class="flex w-full flex-col gap-6">
    <div class="proffeo-ui-surface-card grid grid-cols-1 items-start gap-4 p-3 sm:grid-cols-2">
      <proffeo-ui-select
        [formField]="form.companyId"
        [options]="partyCompanyOptions()"
        [translateLabels]="false"
        errorMessage="ui-forms-this-field-is-required"
        label="time-reports-form-modal-select-company"
      />

      @if (canSelectUser()) {
        <proffeo-ui-select
          [formField]="form.userId"
          [options]="companyUserOptions()"
          [searchable]="true"
          [translateLabels]="false"
          errorMessage="ui-forms-this-field-is-required"
          label="time-reports.absence-dialog.user"
        />
      } @else if (userDisplayName()) {
        <proffeo-ui-input
          [formField]="form.userName"
          prefixIcon="person"
          label="time-reports.absence-dialog.user"
        />
      }
    </div>

    <div class="proffeo-ui-surface-card flex flex-col gap-3 p-3">
      @if (series.active()) {
        <proffeo-ui-choice-group
          [formField]="form.entryMode"
          [options]="entryModeOptions"
          [columns]="2"
          class="mx-auto max-w-xs"
        />
      }

      @if (isLegacyMultiDayEdit()) {
        <p role="note">{{ 'time-reports.absence-dialog.legacy-multi-day-duration' | translate }}</p>
      } @else if (isRangeEntry()) {
        <div class="grid grid-cols-2 items-start gap-4">
          <div class="flex flex-col items-center gap-1">
            <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-from' | translate }}</span>
            <proffeo-ui-time-picker
              [formField]="form.dailyStartTime"
              label="time-reports-form-modal-from"
            />
          </div>
          <div class="flex flex-col items-center gap-1">
            <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-to' | translate }}</span>
            <proffeo-ui-time-picker
              [formField]="form.dailyEndTime"
              label="time-reports-form-modal-to"
            />
          </div>
        </div>
      } @else {
        <div class="flex flex-col items-center gap-1">
          <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports-form-modal-duration' | translate }}</span>
          <proffeo-ui-time-picker
            [formField]="form.durationTime"
            [maxHour]="99"
            label="time-reports-form-modal-duration"
          />
        </div>

        <proffeo-time-buttons (timeSelected)="onDurationPresetSelected($event)" />

        @if (durationInvalid()) {
          <mat-error class="w-full text-right text-sm">
            {{ 'time-reports.absence-dialog.duration-required' | translate }}
          </mat-error>
        }
      }

      <proffeo-ui-select
        [formField]="form.absenceType"
        [options]="writableTypeOptions"
        errorMessage="ui-forms-this-field-is-required"
        label="time-reports.absence-dialog.type"
      />

      @if (unsupportedExistingType(); as unsupportedTypeKey) {
        <p class="m-0 text-sm">
          {{ 'time-reports.absence-dialog.unsupported-type' | translate }}
          {{ unsupportedTypeKey | translate }}
        </p>
      }
    </div>

    <proffeo-report-series-section [series]="series" />

    @if (!series.active()) {
      <section class="proffeo-ui-surface-card flex flex-col gap-3 p-3">
        <proffeo-ui-date-range-picker
          [formField]="form.dateRange"
          [errorMessage]="dateRangeErrorKey()"
          label="time-reports.absence-dialog.date-range"
        />

        <div class="flex flex-col gap-2">
          <span class="proffeo-ui-text-muted text-sm">
            {{ 'time-reports.absence-dialog.include-non-working-days' | translate }}
          </span>
          <div class="flex flex-col gap-2 sm:flex-row sm:gap-6">
            <mat-checkbox
              (change)="onSaturdayChange($event)"
              [checked]="saturdayChecked()"
              [indeterminate]="saturdayIndeterminate()"
            >
              {{ 'time-reports.absence-dialog.include-saturday' | translate }}
            </mat-checkbox>
            <mat-checkbox
              (change)="onSundayChange($event)"
              [checked]="sundayChecked()"
              [indeterminate]="sundayIndeterminate()"
            >
              {{ 'time-reports.absence-dialog.include-sunday' | translate }}
            </mat-checkbox>
          </div>
        </div>

        @if (unknownWeekend() && form().touched()) {
          <mat-error class="text-sm">{{ 'time-reports.absence-dialog.weekend-choice-required' | translate }}</mat-error>
        }
      </section>
    }

    <proffeo-report-summary
      [days]="summaryDays()"
      [durationPerDayMinutes]="summaryDurationMinutes()"
      [modeLabelKey]="summaryAbsenceTypeKey()"
      [periodLabel]="summaryPeriodLabel()"
      [totalMinutes]="summaryTotalMinutes()"
      perDayLabelKey="time-reports.absence-dialog.duration-per-day"
    />

    <proffeo-ui-textarea
      [formField]="form.description"
      errorMessage="errors.required"
      label="time-reports-export.columns.description"
    />

    <proffeo-ui-textarea
      [formField]="form.comments"
      label="time-report-comment"
    />
  </form>

  <div
    dialog-actions
    class="flex w-full justify-center gap-12"
  >
    <proffeo-ui-button
      (clicked)="cancel()"
      variant="primary"
      text="companies-cancel"
    />
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="saveDisabled()"
      variant="accent"
      text="companies-save"
    />
  </div>
</proffeo-ui-dialog>
